import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import {
  DataSourceSettings,
  TABLE_DEFINITION,
  VaFilteredMatTableService,
  VaTableSortService,
} from '@vendasta/va-filter2-table';
import { AccountsAuxiliaryDataTableService } from './auxiliary-data-accounts-table.service';
import { AccountsAuxiliaryDataTableFilterService } from './auxiliary-data-accounts-table-filters.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { tableDefinitionFactory } from './auxiliary-data-accounts-table.model';
import { AccountsCustomFieldsData } from './auxiliary-data-accounts-table.data-model';

export interface AuxDataAccountsActionDependencies {
  openAccountListsModal(
    event: DataSourceSettings,
    vaFilteredMatTableService: VaFilteredMatTableService<AccountsCustomFieldsData>,
    accountsAuxiliaryDataTableService: AccountsAuxiliaryDataTableService,
  ): void;
}

export const AuxDataAccountsActionInjectionToken = new InjectionToken<AuxDataAccountsActionDependencies>(
  'dependencies for the auxiliary-data account table actions',
);

@NgModule()
export class AuxDataAccountsTableActionModule {
  static forRoot(
    configActions: InjectionToken<AuxDataAccountsActionDependencies>,
  ): ModuleWithProviders<AuxDataAccountsTableActionModule> {
    return {
      ngModule: AuxDataAccountsTableActionModule,
      providers: [
        VaTableSortService,
        AccountsAuxiliaryDataTableService,
        VaFilteredMatTableService,
        VaTableSortService,
        AccountsAuxiliaryDataTableFilterService,
        {
          provide: AccountsAuxiliaryDataTableFilterService,
          useClass: AccountsAuxiliaryDataTableFilterService,
        },
        {
          provide: 'fieldSchemas',
          useValue: [],
        },
        {
          provide: TABLE_DEFINITION,
          useFactory: tableDefinitionFactory,
          deps: [AccountsAuxiliaryDataTableFilterService, 'fieldSchemas'],
        },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {} },
        {
          provide: AuxDataAccountsActionInjectionToken,
          useExisting: configActions,
          deps: [],
        },
      ],
    };
  }
}
